/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserWalletOptionRespVo
 */
export interface GetUserWalletOptionRespVo {
    /**
     * 编号
     * @type {number}
     * @memberof GetUserWalletOptionRespVo
     */
    code?: number;
    /**
     * 名称
     * @type {string}
     * @memberof GetUserWalletOptionRespVo
     */
    name?: string;
}

/**
 * Check if a given object implements the GetUserWalletOptionRespVo interface.
 */
export function instanceOfGetUserWalletOptionRespVo(value: object): value is GetUserWalletOptionRespVo {
    return true;
}

export function GetUserWalletOptionRespVoFromJSON(json: any): GetUserWalletOptionRespVo {
    return GetUserWalletOptionRespVoFromJSONTyped(json, false);
}

export function GetUserWalletOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserWalletOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function GetUserWalletOptionRespVoToJSON(json: any): GetUserWalletOptionRespVo {
    return GetUserWalletOptionRespVoToJSONTyped(json, false);
}

export function GetUserWalletOptionRespVoToJSONTyped(value?: GetUserWalletOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

